export function arrayFilter(array){
    return array.filter((obj, index, self) =>
        index === self.findIndex((t) => (
            t.loconum === obj.loconum
        ))
    )
}

export function arraySerialFilter(array){
    return array.filter((obj, index, self) =>
        index === self.findIndex((t) => (
            t.serial === obj.serial
        ))
    )
}

export function formatPhoneNumber(number){
    if(number == null){
        return ""
    }
    return "+33" + number.substring(1)
}

